/**
 * 정책 관리 > 분석 > 정책/객체 최적화 Store
 *
 * @since 2018-06-18
 * @author devp021
 */

import {getCodeJsonRow} from '~/utils/device-common' // 코드 리스트 가져오기
import resultFactory from '~/utils/resultFactory'

export const state = () => ({
  dummy: 1000,
  apiUrl: {
    unusedFwRule: '/api/pm/unused-fw-rule', // 미사용 정책 조회 API
    unusedFwObj: '/api/pm/unused-fw-obj', // 정책 내 미사용 객체 조회 API
    expiredFwRule: '/api/pm/expired-fw-rule', // 만료 및 만료 예정 정책 조회 API
    overAllowedFwRule: '/api/pm/over-allowed-fw-rule', // 과다 허용 정책 조회 API
    confFwRule: '/api/pm/over-allowed-fw-rule-conf', // 탐지 규칙 조회 API
    fwRuleDetail: '/api/pm/fw-rule-detail', // 정책 상세 정보 조회 API
    deleteFwRuleDev: '/api/pm/delete-fw-rule-dev', // 장비에서 정책 삭제 API
    disableFwRuleDev: '/api/pm/disable-fw-rule-dev', // 장비에서 정책 미사용 처리 API
    deleteFwObjDev: '/api/pm/delete-fw-obj-dev' // 장비의 정책에서 객체 삭제 API
  },
  confDataList: [],
  unusedFwRuleSearchData: {
    unusedDate: 1, // 미사용 일자
    deviceUname: '', // 장비 이름
    deviceIdList: [] // 장비 ID 리스트
  },
  filterContents: {
    searchType: 0, // 0: 주소 입력이 없거나 해제인 경우, 1: 출발지 주소, 2: 목적지 주소
    searchIp: ''
  },
  unusedFwObjSearchData: {
    unusedDate: 1, // 미사용 일자
    deviceUname: '', // 장비 이름
    deviceIdList: [] // 장비 ID 리스트
  },
  expiredFwRuleSearchData: {
    unusedDate: 7, // 미사용 일자
    deviceUname: '', // 장비 이름
    deviceIdList: [] // 장비 ID 리스트
  },
  unusedFwRuleList: [], // 미사용 정책 목록
  unusedFwRuleSubList: [], // 미사용 정책 하위 목록
  unusedFwObjList: [], // 정책 내 미사용 객체 목록
  unusedFwObjSubList2: [], // 정책 내 미사용 객체 하위 목록 (depth 2)
  unusedFwObjSubList3: [], // 정책 내 미사용 객체 하위 목록 (depth 3)
  expiredFwRuleList: [], // 만료 및 만료 예정 정책 목록
  expiredFwRuleSubList: [], // 만료 및 만료 예정 정책 하위 목록
  overAllowedFwRuleList: [], // 과다 허용 정책 목록
  overAllowedFwRuleSubList3: [], // 과다 허용 정책 하위 목록 (depth 3)
  // fwRuleDetailList: [], // 정책 상세 정보 목록 // 미사용
  policyMngConfigTypeGroup: [], // 정책 관리 설정 유형 그룹
  policyMngConfigTypeName: '' // 정책 관리 설정 유형 이름
})

export const mutations = {
  // 정책 관리 설정 유형 그룹 설정
  setPolicyMngConfigTypeGroup (state) {
    state.policyMngConfigTypeGroup = getCodeJsonRow('policy_mng_config_type')
  },
  // 정책 관리 설정 유형 그룹의 특정 이름 설정
  setPolicyMngConfigTypeName (state, key) {
    for (let i = 0; i < state.policyMngConfigTypeGroup.length; i++) { // forEach로 하면 마지막 항목까지 루프 (break 불가)
      if (key === state.policyMngConfigTypeGroup[i].key) {
        state.policyMngConfigTypeName = state.policyMngConfigTypeGroup[i].val
        break
      }
    }
  },

  // 미사용 정책 목록 설정
  setUnusedFwRuleList (state, data) {
    state.unusedFwRuleList = Object.freeze(_.cloneDeep(data))
  },
  clearUnusedFwRuleList (state) {
    state.unusedFwRuleList = []
  },
  // 미사용 정책 하위 목록 설정
  setUnusedFwRuleSubList (state, data) {
    state.unusedFwRuleSubList = Object.freeze(_.cloneDeep(data))
  },
  clearUnusedFwRuleSubList (state) {
    state.unusedFwRuleSubList = []
  },
  // 정책 내 미사용 객체 목록 설정
  setUnusedFwObjList (state, data) {
    state.unusedFwObjList = Object.freeze(_.cloneDeep(data))
  },
  clearUnusedFwObjList (state) {
    state.unusedFwObjList = []
  },
  // 정책 내 미사용 객체 하위 목록 설정 (depth 2)
  setUnusedFwObjSubList2 (state, data) {
    state.unusedFwObjSubList2 = Object.freeze(_.cloneDeep(data))
  },
  clearUnusedFwObjSubList2 (state) {
    state.unusedFwObjSubList2 = []
  },
  // 정책 내 미사용 객체 하위 목록 설정 (depth 3)
  setUnusedFwObjSubList3 (state, data) {
    state.unusedFwObjSubList3 = Object.freeze(_.cloneDeep(data))
  },
  clearUnusedFwObjSubList3 (state) {
    state.unusedFwObjSubList3 = []
  },
  // 만료 및 만료 예정 정책 목록 설정
  setExpiredFwRuleList (state, data) {
    state.expiredFwRuleList = Object.freeze(_.cloneDeep(data))
  },
  clearExpiredFwRuleList (state) {
    state.expiredFwRuleList = []
  },
  // 만료 및 만료 예정 정책 하위 목록 설정
  setExpiredFwRuleSubList (state, data) {
    state.expiredFwRuleSubList = Object.freeze(_.cloneDeep(data))
  },
  clearExpiredFwRuleSubList (state) {
    state.expiredFwRuleSubList = []
  },
  setConfFwRuleList (state, data) {
    state.confDataList = Object.freeze(_.cloneDeep(data))
  },
  clearConfFwRuleList (state) {
    state.confDataList = []
  },
  // 과다 허용 정책 목록 설정
  setOverAllowedFwRuleList (state, data) {
    state.overAllowedFwRuleList = Object.freeze(_.cloneDeep(data))
  },
  clearOverAllowedFwRuleList (state) {
    state.overAllowedFwRuleList = []
  },
  // 과다 허용 정책 하위 목록 설정 (depth 3)
  setOverAllowedFwRuleSubList3 (state, data) {
    state.overAllowedFwRuleSubList3 = Object.freeze(_.cloneDeep(data))
  },
  clearOverAllowedFwRuleSubList3 (state) {
    state.overAllowedFwRuleSubList3 = []
  },
  // 정책 상세 정보 목록 설정 // 미사용
  // setFwRuleDetailList (state, data) {
  //   state.fwRuleDetailList = _.cloneDeep(data)
  // },
  // 검색 조건 설정 저장
  setSearchCondition (state, data) {
    if (data.type === 'clear') {
      state.filterContents = {
        searchType: 0, // 0: 주소 입력이 없거나 해제인 경우, 1: 출발지 주소, 2: 목적지 주소
        searchIp: ''
      }
      state.unusedFwRuleSearchData = {
        unusedDate: 1, // 미사용 일자
        deviceUname: '', // 장비 이름
        deviceIdList: [] // 장비 ID 리스트
      }
      state.unusedFwObjSearchData = {
        unusedDate: 1, // 미사용 일자
        deviceUname: '', // 장비 이름
        deviceIdList: [] // 장비 ID 리스트
      }
      state.expiredFwRuleSearchData = {
        unusedDate: 7, // 미사용 일자
        deviceUname: '', // 장비 이름
        deviceIdList: [] // 장비 ID 리스트
      }
    } else if (data.type === 'unusedFwRule') {
      state.unusedFwRuleSearchData = {
        unusedDate: data.unusedDate, // 미사용 일자
        deviceUname: data.deviceUname, // 장비 이름
        deviceIdList: data.deviceIdList // 장비 ID 리스트
      }
    } else if (data.type === 'unusedFwObj') {
      state.unusedFwObjSearchData = {
        unusedDate: data.unusedDate, // 미사용 일자
        deviceUname: data.deviceUname, // 장비 이름
        deviceIdList: data.deviceIdList // 장비 ID 리스트
      }
    } else if (data.type === 'expiredFwRule') {
      state.expiredFwRuleSearchData = {
        unusedDate: data.unusedDate, // 미사용 일자
        deviceUname: data.deviceUname, // 장비 이름
        deviceIdList: data.deviceIdList // 장비 ID 리스트
      }
    }
  },
  // 필터 조건 설정 저장
  setFilterCondition (state, data) {
    if (data.type === 'unlock') {
      state.filterContents = {
        searchType: 0, // 0: 주소 입력이 없거나 해제인 경우, 1: 출발지 주소, 2: 목적지 주소
        searchIp: ''
      }
    } else {
      state.filterContents = {
        searchType: data.searchType, // 0: 주소 입력이 없거나 해제인 경우, 1: 출발지 주소, 2: 목적지 주소
        searchIp: data.searchIp
      }
    }
  }
}

export const actions = {
  // 미사용 정책 목록 조회
  async getUnusedFwRuleList ({commit, state}) {
    let res = {
      code: 'nok',
      result: {}
    }
    const param = {
      unused_date: state.unusedFwRuleSearchData.unusedDate,
      device_id_list: '[' + state.unusedFwRuleSearchData.deviceIdList + ']'
    }

    try {
      res = await this.$axios.$post(state.apiUrl.unusedFwRule + '/' + '0', param, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('setUnusedFwRuleList', res.result)
      }
      return res
    } catch (e) {
      // res.code = 'nok'
      res.result.msg = e.message
      return res
    }
  },
  // 미사용 정책 하위 목록 조회
  async getUnusedFwRuleSubList ({commit, state}, node) {
    const res = {
      code: 'nok',
      reason: ''
    }
    const param = {
      unused_date: state.unusedFwRuleSearchData.unusedDate,
      device_id_list: '[' + state.unusedFwRuleSearchData.deviceIdList + ']',
      search_type: state.filterContents.searchType, // (빈 값인 경우 0)
      ip: state.filterContents.searchIp // (빈 값인 경우 빈 문자열)
    }

    try {
      const {code, result} = await this.$axios.$post(state.apiUrl.unusedFwRule + '/' + node, param, {loading: false, successAlert: false})
      res.code = code
      if (code === 'ok') {
        commit('setUnusedFwRuleSubList', result)
      } else {
        res.reason = result.msg
      }
      return res
    } catch (e) {
      res.reason = e.message
      return res
    }
  },
  // 정책 내 미사용 객체 목록 조회
  async getUnusedFwObjList ({commit, state}, loading = false) {
    let res = {
      code: 'nok',
      result: {}
    }
    const param = {
      unused_date: state.unusedFwObjSearchData.unusedDate,
      device_id_list: '[' + state.unusedFwObjSearchData.deviceIdList + ']'
    }

    try {
      res = await this.$axios.$post(state.apiUrl.unusedFwObj + '/' + '0' + '/' + '0', param, {loading: loading, successAlert: false})
      if (res.code === 'ok') {
        commit('setUnusedFwObjList', res.result)
      }
      return res
    } catch (e) {
      // res.code = 'nok'
      res.result.msg = e.message
      return res
    }
  },
  // 정책 내 미사용 객체 하위 목록 조회 (depth 2)
  async getUnusedFwObjSubList2 ({commit, state}, node) {
    const res = {
      code: 'nok',
      result: {}
    }
    const param = {
      unused_date: state.unusedFwObjSearchData.unusedDate,
      device_id_list: '[' + state.unusedFwObjSearchData.deviceIdList + ']',
      search_type: state.filterContents.searchType, // (빈 값인 경우 0)
      ip: state.filterContents.searchIp // (빈 값인 경우 빈 문자열)
    }

    try {
      const res = await this.$axios.$post(state.apiUrl.unusedFwObj + '/' + node.fwGrpId + '/' + '0', param, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('setUnusedFwObjSubList2', res.result)
      }
      return res
    } catch (e) {
      // res.code = 'nok'
      res.result.msg = e.message
      return res
    }
  },
  // 정책 내 미사용 객체 하위 목록 조회 (depth 3)
  async getUnusedFwObjSubList3 ({commit, state}, node) {
    const res = {
      code: 'nok',
      result: {}
    }
    const param = {
      unused_date: state.unusedFwObjSearchData.unusedDate,
      device_id_list: '[' + state.unusedFwObjSearchData.deviceIdList + ']'
    }

    try {
      const res = await this.$axios.$post(state.apiUrl.unusedFwObj + '/' + node.fwGrpId + '/' + node.fw_rule_id, param, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('setUnusedFwObjSubList3', res.result)
      }
      return res
    } catch (e) {
      // res.code = 'nok'
      res.result.msg = e.message
      return res
    }
  },
  // 만료 및 만료 예정 정책 목록 조회
  async getExpiredFwRuleList ({commit, state}, loading = false) {
    let res = {
      code: 'nok',
      result: {}
    }
    const param = {
      expire_date: state.expiredFwRuleSearchData.unusedDate,
      device_id_list: '[' + state.expiredFwRuleSearchData.deviceIdList + ']'
    }
    try {
      res = await this.$axios.$post(state.apiUrl.expiredFwRule + '/' + '0', param, {loading: loading, successAlert: false})
      if (res.code === 'ok') {
        commit('setExpiredFwRuleList', res.result)
      }
      return res
    } catch (e) {
      // res.code = 'nok'
      res.result.msg = e.message
      return res
    }
  },
  // 만료 및 만료 예정 정책 하위 목록 조회
  async getExpiredFwRuleSubList ({commit, state}, node) {
    const res = {
      code: 'nok',
      reason: 'FAIL'
    }
    const param = {
      expire_date: state.expiredFwRuleSearchData.unusedDate,
      device_id_list: '[' + state.expiredFwRuleSearchData.deviceIdList + ']',
      search_type: state.filterContents.searchType, // (빈 값인 경우 0)
      ip: state.filterContents.searchIp // (빈 값인 경우 빈 문자열)
    }

    try {
      const {code, result} = await this.$axios.$post(state.apiUrl.expiredFwRule + '/' + node, param, {loading: false, successAlert: false})
      res.code = code
      if (code === 'ok') {
        commit('setExpiredFwRuleSubList', result)
        res.reason = 'SUCCESS'
      } else {
        res.reason = 'FAIL'
      }
      return res
    } catch (e) {
      // res.code = 'nok'
      res.reason = e.message
      return res
    }
  },
  async getConfFwRuleList ({commit, state}) {
    let res = {
      code: 'nok',
      result: {}
    }

    try {
      res = await this.$axios.$get(state.apiUrl.confFwRule, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('setConfFwRuleList', res.result)
      }
      return res
    } catch (e) {
      // res.code = 'nok'
      res.result.msg = e.message
      return res
    }
  },
  // 과다 허용 정책 목록 조회
  async getOverAllowedFwRuleList ({commit, state}, data) {
    let res = {
      code: 'nok',
      result: {}
    }

    try {
      res = await this.$axios.$post(state.apiUrl.overAllowedFwRule + '/' + '0' + '/' + data.policy_mng_config_type, {}, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('setOverAllowedFwRuleList', res.result)
      }
      return res
    } catch (e) {
      // res.code = 'nok'
      res.result.msg = e.message
      return res
    }
  },
  // 과다 허용 정책 하위 목록 조회 (depth 3)
  async getOverAllowedFwRuleSubList3 ({commit, state}, node) {
    let res = {
      code: 'nok',
      result: {}
    }
    const param = {
      search_type: state.filterContents.searchType, // (빈 값인 경우 0)
      ip: state.filterContents.searchIp // (빈 값인 경우 빈 문자열)
    }
    // commit('setOverAllowedFwRuleSubList3', [])

    try {
      res = await this.$axios.$post(state.apiUrl.overAllowedFwRule + '/' + node.fwGrpId + '/' + node.cfgType, param, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('setOverAllowedFwRuleSubList3', res.result)
      }
      return res
    } catch (e) {
      // res.code = 'nok'
      res.result.msg = e.message
      return res
    }
  },
  // 정책 상세 정보 목록 조회 // 미사용.
  // async getFwRuleDetailList ({commit, state}, node) {
  //   const res = {code: 'ok'}
  //   try {
  //     const {code, result} = await this.$axios.$post(state.apiUrl.fwRuleDetail + '/' + node.fw_rule_id, {}, {loading: false, successAlert: false})
  //     if (code === 'ok') {
  //       commit('setFwRuleDetailList', result)
  //       res.reason = 'SUCCESS'
  //     } else {
  //       res.reason = 'FAIL'
  //     }
  //     return res
  //   } catch (e) {
  //     res.code = 'nok'
  //     res.reason = e.message
  //     return res
  //   }
  // },
  // 장비에서 정책 삭제
  async onDelUnusedFwRuleCommand ({ commit, state }, payload) {
    const delList = []
    if (payload.data.length > 0) {
      payload.data.forEach((item) => {
        delList.push({fw_rule_id: item.fw_rule_id, fw_rule_id_num: item.fw_rule_id_num, fw_rule_uname: item.fw_rule_uname})
      })
    }
    try {
      const data = await this.$axios.$delete(`${state.apiUrl.deleteFwRuleDev}/${payload.device_id}`, {data: {type: payload.type, items: delList}}, {loading: false, successAlert: false})
      return resultFactory(commit, {length: delList.length, data: data, action: null, param: 'delete'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 장비에서 정책 Disable
  async onDisableUnusedFwRuleCommand ({ commit, state, dispatch }, payload) {
    const editList = []
    if (payload.data.length > 0) {
      payload.data.forEach((item) => {
        editList.push({fw_rule_id: item.fw_rule_id, fw_rule_id_num: item.fw_rule_id_num, fw_rule_uname: item.fw_rule_uname})
      })
    }
    try {
      const data = await this.$axios.$put(`${state.apiUrl.disableFwRuleDev}/${payload.device_id}`, {type: payload.type, items: editList}, {loading: false, successAlert: false})
      return resultFactory(commit, {length: editList.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 장비의 정책에서 객체 삭제
  async onDelUnusedFwObjCommand ({ commit, state }, payload) {
    const delList = []
    if (payload.data.length > 0) {
      payload.data.forEach((item) => {
        delList.push({addr_obj_id: item.addr_obj_id, addr_obj_id_num: item.addr_obj_id_num, addr_obj_uname: item.addr_obj_uname, addr_obj_type: item.addr_obj_type, fw_rule_addr_obj_type: item.fw_rule_addr_obj_type})
      })
    }
    try {
      const data = await this.$axios.$delete(`${state.apiUrl.deleteFwObjDev}/${payload.device_id}/${payload.fw_rule_id}`,
        {data: {type: payload.type, fw_rule_id_num: payload.fw_rule_id_num, fw_rule_uname: payload.fw_rule_uname, items: delList}}, {loading: false, successAlert: false})
      return resultFactory(commit, {length: delList.length, data: data, action: null, param: 'delete'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
}

export const getters = {}
export const strict = false
